var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('van-form', _vm._g(_vm._b({
        ref: "form",
        attrs: {
            "scroll-to-error": _vm.scrollToError
        },
        on: {
            "failed": _setup.onFailed
        }
    }, 'van-form', _setup.props, false), _vm.$listeners), [
        _vm._t("default")
    ], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };
